// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hTo597hom5Sfnv8sxnaC{display:flex;flex-direction:column;gap:4px}`, "",{"version":3,"sources":["webpack://./src/widgets/TriggerActions/ui/TriggerDetailsModal/ui/DetailsTriggerBody/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":[".triggerParamsWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triggerParamsWrapper": `hTo597hom5Sfnv8sxnaC`
};
export default ___CSS_LOADER_EXPORT___;
